import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=a6e292c6&scoped=true&"
import script from "./Details.vue?vue&type=script&lang=ts&"
export * from "./Details.vue?vue&type=script&lang=ts&"
import style0 from "./Details.vue?vue&type=style&index=0&id=a6e292c6&prod&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e292c6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Guidance: require('/opt/atlassian/pipelines/agent/build/components/guidance/Guidance.vue').default,Modal: require('/opt/atlassian/pipelines/agent/build/components/Modal.vue').default})
